<template>
  <div class="contentBox" :class="device=='mobile'?'mobileBox':''">
    <web ref="web"></web>
    <div class="detail">
      <p class="title">训练营练习报告</p>
      <p class="msg">距离结营时间还剩: {{detailData.diff_day}}天</p>
      <p class="msg1">{{login_type==1?'每道题都是成长，进步路上的你超棒!':'别忽视孩子的坚持，你的肯定是他的加油站！'}}</p>
      <div class="progress">
        <p class="result-title">总练习进度</p>
        <div class="line">
          <div class="bg" :style="{ width: detailData.rate + '%'}"></div>
          <p>{{detailData.rate}}%</p>
        </div>
      </div>
      <div class="progress">
        <p class="result-title">总时间长度</p>
        <div class="line">
          <div class="bg" :style="{ width: detailData.time_progress + '%'}"></div>
          <p>{{detailData.time_progress}}%</p>
        </div>
      </div>
      <div class="result-item">
        <p class="result-title">母题讲解练习</p>
        <div class="result-list">
          <div class="list-item" v-for="(item,index) in detailData.videos" :key="index">
            <p class="list-title">第{{$refs.web.numberToChinese(item.week)}}周</p>
            <div class="list-cont">
              <div class="list-txt">
                <p class="num">{{item.complete}}<span>个</span></p>
                <p class="status">已完成</p>
              </div>
              <div class="list-txt list-txt2">
                <p class="num">{{item.incomplete}}<span>个</span></p>
                <p class="status">未完成</p>
              </div>
              <div class="list-txt">
                <p class="num">{{item.rate}}<span>%</span></p>
                <p class="status">母题讲解练习进度</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="result-item">
        <p class="result-title">习题刻意练习</p>
        <div class="result-list">
          <div class="list-item" v-for="(item,index) in detailData.topics" :key="index">
            <p class="list-title">第{{$refs.web.numberToChinese(item.week)}}周</p>
            <div class="list-cont">
              <div class="list-txt">
                <p class="num">{{item.complete}}<span>个</span></p>
                <p class="status">已完成</p>
              </div>
              <div class="list-txt list-txt2">
                <p class="num">{{item.incomplete}}<span>个</span></p>
                <p class="status">未完成</p>
              </div>
              <div class="list-txt">
                <p class="num">{{item.rate}}<span>%</span></p>
                <p class="status">习题刻意练习进度</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="result-item">
        <p class="result-title">每周正确率</p>
        <div ref="chart" class="chartBox"></div>
        <span class="total">总正确率: {{detailData.acc}}%</span>
      </div>
      <div class="result-item cont">
          <p class="result-title">每周错题复盘</p>
          <div class="result-list">
            <div class="list-item" v-for="(item,index) in detailData.replay" :key="index">
              <p class="list-title">第{{$refs.web.numberToChinese(item.week)}}周</p>
              <div class="list-cont list-cont1" v-if="item.week_topic_error_num == 0">
                <img src="./../assets/images/icon18.png" alt="">
                <p>无错题</p>
              </div>
              <div class="list-cont" v-else>
                <div class="list-txt">
                  <p class="num">{{item.complete}}<span>个</span></p>
                  <p class="status">已完成</p>
                </div>
                <div class="list-txt list-txt2">
                  <p class="num">{{item.incomplete}}<span>个</span></p>
                  <p class="status">未完成</p>
                </div>
                <div class="list-txt">
                  <p class="num">{{item.rate}}<span>%</span></p>
                  <p class="status">错题复盘率</p>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import { getReport } from "@/assets/js/api";
import web from './../components/comment/web.vue';
import * as echarts from 'echarts';
export default {
  name: "login",
  data() {
    return {
      token:'',
      rmid:'',
      detailData:'',
      device:'',
      login_type:''
    };
  },
  components: {
    web
  },
  mounted(){
    document.title = '训练营练习报告'
    var userData = JSON.parse(localStorage.getItem('identityData'));
    this.token = userData.apiToken;
    this.login_type = userData.login_type;
    this.rmid = this.$route.query.rmid;
    this.getDeatil();
    this.device = this.$refs.web.device;
    if(this.device == 'mobile'){
      this.$refs.web.font_resize();
    };
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.chartResize);
  },
  methods: {
    async getDeatil(){
      var that = this;
      try {
        const response = await getReport({rmid:this.$route.query.rmid},this.token);
        if(response.code == 200){
          that.detailData = response.data.report;
          var list1 = [];
          var list2 = [];
          response.data.report.accuracys.forEach(function(item,index){
            list1.push('第'+item.week+'周正确率')
            list2.push(item.acc)
          });
          that.initChart(list1,list2);
          window.addEventListener('resize', this.chartResize);
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    initChart(list1,list2) {
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(this.$refs.chart);
      // 指定图表的配置项和数据
      const option = {
        tooltip: {
          show: true,
        },
        legend: {
          data:['正确率']
        },
        xAxis: {
            type: 'category',
            data: list1
        },
        yAxis: {
            type: 'value'
        },
        series: [{
          data: list2,
          type: 'line',
          label: {
              show: true // 显示数值
          }
        }]
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },

    chartResize() {
      this.$nextTick(() => {
        if (this.chart) {
          this.chart.resize();
        }
      });
    },
    
  },

  
};
</script>
<style scoped>
  .contentBox{
    background-image: url(~@/assets/images/bg2.png);
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    padding: 101px 0 75px;
    overflow-y: auto;
  }

  .title{
    color: #333333;
    font-size: 65px;
    display: block;
    font-weight: bold;
    text-align: center;
  }

  .msg{
    font-size: 32px;
    color: #777777;
    display: block;
    margin: 10px 0 20px;
    text-align: center;
  }

  .msg1{
    font-size: 40px;
    color: #333333;
    display: block;
    text-align: center;
    margin-bottom: 40px;
  }

  .progress{
    margin-bottom: 20px;
  }

  .progress .line{
    width: 626px;
    height: 34px;
    background-color: #B2CDF9;
    border-radius: 49px;
    position: relative;
    margin: 10px auto 0 ;
  }

  .progress .line .bg{
    width: 10%;
    background-color: #6098F2;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 49px;
  }

  .progress .line p{
    font-size: 24px;
    color: #000000;
    position: absolute;
    top: 50%;
    right: -70px;
    transform: translate(0,-50%);
  }

  .result-title{
    font-size: 32px;
    color: #333333;
    text-align: left;
  }

  .result-title::before{
    content: '';
    width: 8px;
    height: 40px;
    background-color: #6098F2;
    display: inline-block;
    vertical-align: top;
    margin-right: 10px;
  }

  .result-list{
    margin-top: 20px;
  }

  .list-item{
    margin-bottom: 10px;
  }

  .list-title{
    display: block;
    font-size: 20px;
    color: #333333;
    text-align: left;
    margin: 20px 20px 10px;
  }

  .list-cont{
    margin-left: 60px;
  }

  .list-cont1 img{
    width: 100px;
    height: 94px;
    display: inline-block;
    vertical-align: top;
  }

  .list-cont1 p{
    font-size: 26px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
    line-height: 94px;
    margin-left: 30px;
  }

  .list-txt{
    width: 150px;
    height: 150px;
    border-radius: 6px;
    display: inline-block;
    vertical-align: top;
    box-sizing: border-box;
    padding: 33px 39px;
    background-image: url(~@/assets/images/bg3.png);
    background-size: 150px 150px;
  }

  .list-txt .num{
    color: #333333;
    font-size: 28px;
    font-weight: bold;
  }

  .list-txt .num span{
    font-size: 14px;
  }

  .list-txt .status{
    color: #2476F9;
    font-size: 14px;
    margin-top: 10px;
  }

  .list-txt2{
    margin: 0 30px;
    background-image: url(~@/assets/images/bg4.png);
  }

  .list-txt2 p.num,
  .list-txt2 p.status{
    color: #777777;
  }
  
  .detail{
    width: 50%;
    margin: 0 auto;
    text-align: center;
  }

  .chartBox{
    width: 100%;
    height: 500px;
    display: block;
    margin-top: 30px;
  }

  .total{
    font-size: 32px;
    color: #333333;
    margin: 30px 0;
    display: block;
    text-align: left;
  }

  .mobileBox .detail{
    width: 80%;
  }

  .mobileBox .title{
    font-size: .3rem;
  }

  .mobileBox .msg{
    font-size: .24rem;
  }

  .mobileBox .msg1{
    font-size: .28rem;
  }

  .mobileBox .result-title{
    font-size: .24rem;
  }

  .mobileBox .progress .line p{
    font-size: .2rem;
  }

  .mobileBox .list-title{
    font-size: .22rem;
  }

  .mobileBox .list-txt .num{
    font-size: .28rem;
  }

  .mobileBox .list-txt .status{
    font-size: .14rem;
  }

  .mobileBox .list-txt{
    width: 1.4rem;
    height: 1.4rem;
    background-size: 1.4rem 1.4rem;
    padding: .39rem .1rem;
  }

  .mobileBox .total{
    font-size: .24rem;
  }
</style>



// WEBPACK FOOTER //
// src/identity/result.vue